import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { CertificateDto, CertificateParameterValueDto } from "../generated-api";
import { renderDate } from "./render";
import { TEMPLATE_PARAM_DATE } from "../constants/template";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const loadImage = (url: string): Promise<string> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.onload = function () {
      const image = this as HTMLImageElement;
      const canvas = document.createElement("CANVAS") as HTMLCanvasElement;
      const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
      canvas.height = image.naturalHeight;
      canvas.width = image.naturalWidth;
      ctx.drawImage(image, 0, 0);
      resolve(canvas.toDataURL());
    };
    img.src = url;
  });
};

function getLabelDocDefinition(
  qrCode: any,
  certificateId: string,
  blockChainHash: string,
  templateName: string,
  parameterValues: CertificateParameterValueDto[],
  logo: string,
  companyDisclaimer?: string,
) {
  return {
    pageMargins: [40, 75, 40, 64],
    header: {
        stack:[
          {
            svg: '<svg width="600" height="56"><rect width="600" height="56" style="fill:rgba(86, 96, 100, 1);" /></svg>',
          },
          {
            image: logo,
            fit: [600, 54],
            margin: [40, -55, 40, 0],
          }
        ]
    },
    content: [
      {
        columns:[
          {
            stack:[
              { 
                image: qrCode,
                width: '*',
                fit: [105, 105],
                absolutePosition: { x: 77, y: 133 },
              },
              {
                margin: [-20, 0, 0, 20],
                width: 220,
                svg: `<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 113.4 113.4" style="enable-background:new 0 0 113.4 113.4;" xml:space="preserve">
             <path d="M82.6,82.6H30.8V30.8h51.7V82.6z M31.5,81.9h50.3V31.5H31.5V81.9z"/>
             <path d="M56.7,96.7c-22.1,0-40-18-40-40s18-40,40-40s40,18,40,40S78.8,96.7,56.7,96.7z M56.7,17.4C35,17.4,17.4,35,17.4,56.7
               S35,96,56.7,96S96,78.4,96,56.7S78.4,17.4,56.7,17.4z"/>
             <path d="M56.7,0.7c30.9,0,56,25.1,56,56c0,30.9-25.1,56-56,56s-56-25.1-56-56C0.7,25.8,25.8,0.7,56.7,0.7 M56.7,0
               C25.4,0,0,25.4,0,56.7c0,31.3,25.4,56.7,56.7,56.7s56.7-25.4,56.7-56.7C113.4,25.4,88,0,56.7,0L56.7,0z"/>
             <g>
               <path d="M19.8,22.7l-0.1,0.2l-1.5-0.6c-0.4,0.3-0.7,0.6-1,0.9c-0.6,0.7-0.8,1.5-0.6,2.4s0.7,1.6,1.5,2.3c0.9,0.7,1.8,1.1,2.7,1
                 c0.9-0.1,1.7-0.5,2.4-1.4c0.4-0.5,0.7-1.1,1-1.7l0.2,0.1c-0.1,0.9-0.4,1.8-1,2.5c-0.8,1-1.7,1.5-2.8,1.6c-1.1,0.1-2.1-0.2-3.1-1
                 c-1-0.8-1.6-1.8-1.7-3s0.3-2.3,1.2-3.3c0.4-0.5,0.9-1,1.5-1.4l0.1,0L19.8,22.7z"/>
               <path d="M22.5,17.3l1.1-0.9c0.7-0.6,1.4-1.1,2.1-1.8l0.1,0l0.9,1.6l-0.2,0.2l-1.1-0.8l-2.1,1.7l2,2.5l0.4-0.3
                 c0.3-0.3,0.7-0.5,1-0.9c0.1-0.1,0.1-0.1,0.1-0.2l-0.3-0.7l0.2-0.2c0.3,0.4,0.6,0.7,0.8,0.9c0.2,0.2,0.4,0.5,0.8,0.9L28,19.5
                 L27.4,19c-0.1-0.1-0.2-0.1-0.2,0c-0.4,0.3-0.8,0.6-1.1,0.9l-0.4,0.3l1.4,1.6c0.3,0.3,0.5,0.7,0.8,1l2.2-1.8l-0.4-1.6l0.2-0.2
                 l1.2,1.7l0,0.1c-0.8,0.6-1.5,1.2-2.2,1.8l-1.1,0.9c-0.4,0.3-0.7,0.6-1.1,0.9l-0.2-0.2l0.4-0.6c0.1-0.1,0.1-0.2,0-0.2
                 c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.2-0.3-0.3-0.4-0.5l-3-3.7c-0.1-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.2-0.2-0.3-0.3
                 c-0.1-0.1-0.1-0.1-0.2-0.1l-0.7,0.3l-0.2-0.2C21.8,17.9,22.1,17.6,22.5,17.3z"/>
               <path d="M34.1,16.9c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.2,0.2,0.3,0.2,0.4c0.1,0.1,0.1,0.1,0.2,0.1l0.7-0.1l0.1,0.2
                 c-0.4,0.2-0.8,0.4-1.2,0.6c-0.4,0.2-0.8,0.5-1.3,0.7l-0.1-0.2l0.5-0.5c0.1-0.1,0.1-0.1,0.1-0.2c-0.1-0.1-0.2-0.3-0.2-0.5
                 c-0.1-0.2-0.2-0.4-0.3-0.6l-2.2-4.2c-0.1-0.2-0.2-0.3-0.3-0.5s-0.1-0.3-0.2-0.4c-0.1-0.1-0.1-0.1-0.2-0.1l-0.7,0.1l-0.1-0.2
                 c0.5-0.2,0.9-0.4,1.3-0.7c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.3-0.2,0.5-0.3c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.2-0.1,0.3-0.2
                 c0.8-0.4,1.5-0.6,2-0.5c0.6,0.1,1,0.4,1.3,1c0.3,0.5,0.4,1,0.3,1.5c-0.1,0.5-0.4,0.9-0.9,1.4c0.4,0.2,0.8,0.4,1.1,0.6
                 c0.3,0.2,0.7,0.4,1,0.6s0.6,0.3,0.8,0.4s0.4,0.2,0.6,0.3c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0,0.2,0c0.1,0,0.2,0,0.2,0
                 c0.1,0,0.2,0,0.3-0.1l0.1,0.2c-0.2,0.2-0.4,0.3-0.6,0.4c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3,0
                 c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4-0.1-0.7-0.2c-0.2-0.1-0.5-0.3-0.8-0.5c-0.3-0.2-0.6-0.4-0.9-0.6c-0.3-0.2-0.6-0.4-1-0.6
                 c-0.1-0.1-0.2-0.1-0.2-0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0.1-0.2,0.1l-0.4,0.2L34.1,16.9z M33,14.7
                 c0.2-0.1,0.4-0.2,0.6-0.3c0.6-0.3,1-0.7,1.1-1.1c0.1-0.4,0.1-0.9-0.2-1.4c-0.3-0.5-0.6-0.8-1-0.9c-0.4-0.1-0.9,0-1.4,0.3
                 c-0.1,0.1-0.2,0.1-0.3,0.2s-0.2,0.1-0.3,0.2L33,14.7z"/>
               <path d="M43.9,14.6c-0.5,0.1-1,0.3-1.5,0.5l-0.1-0.2l0.8-0.5c0.1-0.1,0.1-0.1,0.1-0.2c-0.1-0.3-0.2-0.6-0.3-1.1l-1.7-5.6l-2,0.6
                 l0,1.6l-0.2,0.1l-0.8-2l0-0.1c0.9-0.3,1.8-0.5,2.6-0.8l1.5-0.5c0.8-0.3,1.7-0.5,2.6-0.8l0,0l0.2,2.1L45,8l-0.8-1.4l-2,0.6l1.7,5.6
                 c0.1,0.4,0.2,0.8,0.3,1.1c0,0.1,0.1,0.1,0.2,0.1l0.9,0l0.1,0.2C44.9,14.4,44.3,14.5,43.9,14.6z"/>
               <path d="M48.3,8.8l3.2-0.4l0.1,0.8l-3.2,0.4L48.3,8.8z"/>
               <path d="M57.4,12.8c-0.5,0-1,0-1.6,0l0-0.3l0.9-0.2c0.1,0,0.1-0.1,0.2-0.2c0-0.3,0-0.7,0-1.1L57,5.1l-2.1,0l-0.5,1.5l-0.2,0L54,4.5
                 l0,0c1,0,1.9,0.1,2.8,0.1l1.6,0c0.9,0,1.8,0,2.8,0l0,0l-0.4,2.1l-0.2,0l-0.3-1.6l-2.1,0L58,11c0,0.5,0,0.8,0,1.1
                 c0,0.1,0.1,0.2,0.1,0.2l0.9,0.3l0,0.3C58.4,12.8,57.9,12.8,57.4,12.8z"/>
               <path d="M65.5,11.8c0,0.2-0.1,0.4-0.1,0.6c0,0.2-0.1,0.4-0.1,0.5c0,0.1,0,0.2,0.1,0.3l0.6,0.3l0,0.2c-0.5-0.1-0.9-0.2-1.4-0.3
                 c-0.5-0.1-0.9-0.2-1.4-0.3l0-0.3l0.8-0.1c0.1,0,0.2-0.1,0.2-0.1c0-0.2,0.1-0.3,0.1-0.5c0-0.2,0.1-0.4,0.1-0.6l1-4.6
                 c0-0.2,0.1-0.4,0.1-0.5c0-0.2,0.1-0.3,0.1-0.4c0-0.1,0-0.2-0.1-0.2l-0.7-0.4l0-0.2c0.5,0.1,1,0.2,1.4,0.3c0.1,0,0.2,0,0.4,0.1
                 s0.3,0.1,0.5,0.1c0.2,0,0.4,0.1,0.5,0.1s0.2,0,0.3,0.1c0.9,0.2,1.5,0.5,1.9,0.9c0.4,0.4,0.5,1,0.3,1.6c-0.1,0.6-0.4,1-0.8,1.3
                 c-0.4,0.3-0.9,0.5-1.6,0.5c0.2,0.4,0.3,0.8,0.4,1.2c0.1,0.4,0.3,0.7,0.4,1.1c0.1,0.3,0.2,0.6,0.3,0.9c0.1,0.2,0.2,0.5,0.3,0.6
                 c0,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0.1,0.2,0.1l0,0.3c-0.3,0-0.5-0.1-0.7-0.1
                 c-0.2,0-0.3-0.1-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.1s-0.1-0.1-0.2-0.2c-0.1-0.2-0.2-0.4-0.4-0.6
                 s-0.2-0.5-0.3-0.9c-0.1-0.3-0.2-0.7-0.3-1c-0.1-0.4-0.2-0.7-0.4-1.1c0-0.1-0.1-0.2-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2
                 c0,0-0.1-0.1-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.1L65.5,11.8z M66,9.4c0.2,0.1,0.4,0.1,0.6,0.2c0.7,0.1,1.2,0.1,1.5-0.1
                 c0.4-0.2,0.6-0.6,0.8-1.2c0.1-0.6,0.1-1-0.2-1.4c-0.2-0.3-0.7-0.6-1.3-0.7c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.3,0-0.4-0.1L66,9.4z"/>
               <path d="M78.7,9.3l-0.6,7.6c0,0.3,0,0.5,0,0.6c0,0.1,0.1,0.2,0.2,0.3l0.4,0.4l-0.1,0.2c-0.5-0.2-0.9-0.4-1.3-0.6
                 c-0.4-0.2-0.9-0.4-1.4-0.6L76,17l0.6,0.1c0.1,0,0.1,0,0.2,0s0.1-0.1,0.1-0.1c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.3,0.1-0.5l0.2-1.7
                 l-2.6-1.2l-1.2,1.2c-0.2,0.2-0.3,0.3-0.4,0.4c-0.1,0.1-0.2,0.2-0.2,0.2c0,0.1,0,0.1,0,0.2c0,0,0.1,0.1,0.1,0.1l0.4,0.4L73.3,16
                 c-0.5-0.2-0.9-0.4-1.2-0.6c-0.3-0.1-0.7-0.3-1.1-0.5l0.1-0.2l0.6,0.1c0.2,0,0.3,0,0.4-0.1s0.2-0.2,0.4-0.3l5.7-5.3L78.7,9.3z
                  M75,12.8l2.2,1l0.3-3.4L75,12.8z"/>
               <path d="M88.7,18.1L88.5,18l0.6-1.5c-0.3-0.4-0.6-0.7-1-0.9c-0.8-0.6-1.6-0.7-2.4-0.5s-1.6,0.8-2.2,1.6c-0.7,0.9-1,1.8-0.9,2.8
                 s0.6,1.7,1.5,2.4c0.5,0.4,1.1,0.7,1.8,0.9l-0.1,0.2c-0.9,0-1.8-0.3-2.6-0.9c-1-0.7-1.6-1.7-1.8-2.7s0.1-2.1,0.9-3.1
                 c0.8-1.1,1.8-1.7,2.9-1.8s2.3,0.2,3.4,1c0.5,0.4,1,0.9,1.5,1.4l0,0.1L88.7,18.1z"/>
               <path d="M94.3,20.5l1,1.1c0.6,0.6,1.2,1.3,1.9,2l0,0.1l-1.6,1l-0.2-0.1l0.8-1.2l-1.8-2l-2.4,2.2l0.4,0.4c0.3,0.3,0.6,0.6,0.9,1
                 c0.1,0.1,0.2,0.1,0.2,0l0.7-0.4l0.2,0.2c-0.4,0.4-0.7,0.6-0.9,0.8c-0.2,0.2-0.5,0.4-0.9,0.8l-0.2-0.2l0.5-0.7
                 c0.1-0.1,0.1-0.2,0-0.2c-0.3-0.4-0.6-0.7-0.9-1l-0.4-0.4l-1.6,1.4c-0.3,0.3-0.6,0.6-0.9,0.9l1.9,2.1l1.6-0.5l0.2,0.2l-1.6,1.3
                 l-0.1,0c-0.7-0.8-1.3-1.5-1.9-2.1l-0.9-1c-0.3-0.3-0.6-0.7-1-1.1l0.2-0.2l0.6,0.4c0.1,0.1,0.2,0.1,0.2,0c0.1-0.1,0.2-0.2,0.4-0.3
                 c0.1-0.1,0.3-0.3,0.5-0.4l3.5-3.2c0.1-0.1,0.3-0.3,0.4-0.4s0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.2,0.1-0.2l-0.3-0.7l0.2-0.2
                 C93.6,19.8,93.9,20.2,94.3,20.5z"/>
               <path d="M100.1,27.8c0.3,0.5,0.5,1,0.4,1.5c-0.1,0.5-0.4,0.9-0.9,1.3C99.1,31,98.6,31.1,98,31c-0.5-0.1-1-0.4-1.3-1
                 c-0.3-0.5-0.5-1-0.4-1.6s0.4-1,0.9-1.3c0.5-0.3,1-0.4,1.6-0.3C99.4,27,99.8,27.3,100.1,27.8z M99.9,27.9c-0.3-0.4-0.6-0.7-1-0.7
                 c-0.4-0.1-0.9,0-1.3,0.3c-0.5,0.3-0.7,0.7-0.8,1.1s0,0.9,0.3,1.3c0.3,0.4,0.6,0.7,1.1,0.8c0.4,0.1,0.9,0,1.3-0.4
                 c0.4-0.3,0.7-0.7,0.8-1.1C100.3,28.8,100.2,28.4,99.9,27.9z M98.1,28.8c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1
                 c0,0-0.1,0.1-0.1,0.1l0.1,0.2l-0.1,0.1c-0.1-0.1-0.1-0.2-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.2
                 c-0.1-0.1-0.1-0.2-0.2-0.2l0.1-0.1l0.2,0.2c0,0,0.1,0,0.1,0c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1-0.1,0.2-0.1l0.5-0.3
                 c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1l-0.1-0.3l0.1-0.1c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.2,0.2,0.2
                 c0,0,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.2,0.2,0.2c0.3,0.5,0.3,0.8,0,1c-0.2,0.1-0.4,0.1-0.7-0.1c-0.1,0.2-0.2,0.3-0.2,0.5
                 c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0.1,0.2l-0.1,0.1c-0.1-0.1-0.1-0.2-0.2-0.2C98.1,30.2,98,30.1,98,30
                 c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.1-0.3,0.2-0.4c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0-0.1l-0.1-0.1L98.1,28.8z
                  M98.4,28.6c0,0,0,0.1,0.1,0.1c0.2,0.3,0.4,0.3,0.6,0.2c0.1-0.1,0.2-0.2,0.2-0.3s0-0.2-0.1-0.3c0,0-0.1-0.1-0.1-0.1L98.4,28.6z"/>
             </g>
             <g>
               <path d="M93.6,90.7l0.1-0.2l1.5,0.6c0.4-0.3,0.7-0.6,1-0.9c0.6-0.7,0.8-1.5,0.6-2.4s-0.7-1.6-1.5-2.3c-0.9-0.7-1.8-1.1-2.7-1
                 c-0.9,0.1-1.7,0.5-2.4,1.4c-0.4,0.5-0.7,1.1-1,1.7L89,87.5c0.1-0.9,0.4-1.8,1-2.5c0.8-1,1.7-1.5,2.8-1.6c1.1-0.1,2.1,0.2,3.1,1
                 c1,0.8,1.6,1.8,1.7,3s-0.3,2.3-1.2,3.3c-0.4,0.5-0.9,1-1.5,1.4l-0.1,0L93.6,90.7z"/>
               <path d="M90.9,96.1L89.8,97c-0.7,0.6-1.4,1.1-2.1,1.8l-0.1,0l-0.9-1.6l0.2-0.2l1.1,0.8l2.1-1.7l-2-2.5l-0.4,0.3
                 c-0.3,0.3-0.7,0.5-1,0.9c-0.1,0.1-0.1,0.1-0.1,0.2l0.3,0.7l-0.2,0.2c-0.3-0.4-0.6-0.7-0.8-0.9c-0.2-0.2-0.4-0.5-0.8-0.9l0.2-0.2
                 l0.7,0.5c0.1,0.1,0.2,0.1,0.2,0c0.4-0.3,0.8-0.6,1.1-0.9l0.4-0.3l-1.4-1.6c-0.3-0.3-0.5-0.7-0.8-1l-2.2,1.8l0.4,1.6l-0.2,0.2
                 l-1.2-1.7l0-0.1c0.8-0.6,1.5-1.2,2.2-1.8l1.1-0.9c0.4-0.3,0.7-0.6,1.1-0.9L87,89l-0.4,0.6c-0.1,0.1-0.1,0.2,0,0.2
                 c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.3,0.3,0.4,0.5l3,3.7c0.1,0.2,0.2,0.3,0.3,0.4c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0.1,0.2,0.1
                 l0.7-0.3l0.2,0.2C91.6,95.5,91.2,95.8,90.9,96.1z"/>
               <path d="M79.3,96.5c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.2-0.2-0.3-0.2-0.4c-0.1-0.1-0.1-0.1-0.2-0.1l-0.7,0.1l-0.1-0.2
                 c0.4-0.2,0.8-0.4,1.2-0.6c0.4-0.2,0.8-0.5,1.3-0.7l0.1,0.2l-0.5,0.5c-0.1,0.1-0.1,0.1-0.1,0.2c0.1,0.1,0.2,0.3,0.2,0.5
                 c0.1,0.2,0.2,0.4,0.3,0.6l2.2,4.2c0.1,0.2,0.2,0.3,0.3,0.5s0.1,0.3,0.2,0.4c0.1,0.1,0.1,0.1,0.2,0.1l0.7-0.1l0.1,0.2
                 c-0.5,0.2-0.9,0.4-1.3,0.7c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.3,0.2-0.5,0.3c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0.1-0.2,0.1-0.3,0.2
                 c-0.8,0.4-1.5,0.6-2,0.5c-0.6-0.1-1-0.4-1.3-1c-0.3-0.5-0.4-1-0.3-1.5c0.1-0.5,0.4-0.9,0.9-1.4c-0.4-0.2-0.8-0.4-1.1-0.6
                 c-0.3-0.2-0.7-0.4-1-0.6s-0.6-0.3-0.8-0.4s-0.4-0.2-0.6-0.3c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.2,0
                 c-0.1,0-0.2,0-0.3,0.1l-0.1-0.2c0.2-0.2,0.4-0.3,0.6-0.4c0.1-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0
                 c0.1,0,0.2,0,0.3,0c0.2,0,0.4,0.1,0.7,0.2c0.2,0.1,0.5,0.3,0.8,0.5c0.3,0.2,0.6,0.4,0.9,0.6c0.3,0.2,0.6,0.4,1,0.6
                 c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1l0.4-0.2L79.3,96.5z M80.4,98.7
                 c-0.2,0.1-0.4,0.2-0.6,0.3c-0.6,0.3-1,0.7-1.1,1.1c-0.1,0.4-0.1,0.9,0.2,1.4c0.3,0.5,0.6,0.8,1,0.9c0.4,0.1,0.9,0,1.4-0.3
                 c0.1-0.1,0.2-0.1,0.3-0.2s0.2-0.1,0.3-0.2L80.4,98.7z"/>
               <path d="M69.5,98.7c0.5-0.1,1-0.3,1.5-0.5l0.1,0.2L70.3,99c-0.1,0.1-0.1,0.1-0.1,0.2c0.1,0.3,0.2,0.6,0.3,1.1l1.7,5.6l2-0.6l0-1.6
                 l0.2-0.1l0.8,2l0,0.1c-0.9,0.3-1.8,0.5-2.6,0.8l-1.5,0.5c-0.8,0.3-1.7,0.5-2.6,0.8l0,0l-0.2-2.1l0.2-0.1l0.8,1.4l2-0.6l-1.7-5.6
                 c-0.1-0.4-0.2-0.8-0.3-1.1c0-0.1-0.1-0.1-0.2-0.1l-0.9,0l-0.1-0.2C68.5,99,69,98.9,69.5,98.7z"/>
               <path d="M65.1,104.6l-3.2,0.4l-0.1-0.8l3.2-0.4L65.1,104.6z"/>
               <path d="M56,100.6c0.5,0,1,0,1.6,0l0,0.3l-0.9,0.2c-0.1,0-0.1,0.1-0.2,0.2c0,0.3,0,0.7,0,1.1l-0.1,5.8l2.1,0l0.5-1.5l0.2,0l0.1,2.1
                 l0,0c-1,0-1.9-0.1-2.8-0.1l-1.6,0c-0.9,0-1.8,0-2.8,0l0,0l0.4-2.1l0.2,0l0.3,1.6l2.1,0l0.1-5.8c0-0.5,0-0.8,0-1.1
                 c0-0.1-0.1-0.2-0.1-0.2l-0.9-0.3l0-0.3C55,100.6,55.5,100.6,56,100.6z"/>
               <path d="M47.9,101.6c0-0.2,0.1-0.4,0.1-0.6c0-0.2,0.1-0.4,0.1-0.5c0-0.1,0-0.2-0.1-0.3l-0.6-0.3l0-0.2c0.5,0.1,0.9,0.2,1.4,0.3
                 c0.5,0.1,0.9,0.2,1.4,0.3l0,0.3l-0.8,0.1c-0.1,0-0.2,0.1-0.2,0.1c0,0.2-0.1,0.3-0.1,0.5c0,0.2-0.1,0.4-0.1,0.6l-1,4.6
                 c0,0.2-0.1,0.4-0.1,0.5c0,0.2-0.1,0.3-0.1,0.4c0,0.1,0,0.2,0.1,0.2l0.7,0.4l0,0.2c-0.5-0.1-1-0.2-1.4-0.3c-0.1,0-0.2,0-0.4-0.1
                 s-0.3-0.1-0.5-0.1c-0.2,0-0.4-0.1-0.5-0.1s-0.2,0-0.3-0.1c-0.9-0.2-1.5-0.5-1.9-0.9c-0.4-0.4-0.5-1-0.3-1.6c0.1-0.6,0.4-1,0.8-1.3
                 c0.4-0.3,0.9-0.5,1.6-0.5c-0.2-0.4-0.3-0.8-0.4-1.2c-0.1-0.4-0.3-0.7-0.4-1.1c-0.1-0.3-0.2-0.6-0.3-0.9c-0.1-0.2-0.2-0.5-0.3-0.6
                 c0-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2-0.1-0.2-0.1l0-0.3c0.3,0,0.5,0.1,0.7,0.1
                 c0.2,0,0.3,0.1,0.4,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0.1,0.2,0.1s0.1,0.1,0.2,0.2c0.1,0.2,0.2,0.4,0.4,0.6s0.2,0.5,0.3,0.9
                 c0.1,0.3,0.2,0.7,0.3,1c0.1,0.4,0.2,0.7,0.4,1.1c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0,0.1,0.1,0.2,0.1
                 c0.1,0,0.1,0.1,0.2,0.1l0.4,0.1L47.9,101.6z M47.4,104c-0.2-0.1-0.4-0.1-0.6-0.2c-0.7-0.1-1.2-0.1-1.5,0.1
                 c-0.4,0.2-0.6,0.6-0.8,1.2c-0.1,0.6-0.1,1,0.2,1.4c0.2,0.3,0.7,0.6,1.3,0.7c0.1,0,0.2,0,0.3,0.1c0.1,0,0.3,0,0.4,0.1L47.4,104z"/>
               <path d="M34.7,104.1l0.6-7.6c0-0.3,0-0.5,0-0.6c0-0.1-0.1-0.2-0.2-0.3l-0.4-0.4l0.1-0.2c0.5,0.2,0.9,0.4,1.3,0.6
                 c0.4,0.2,0.9,0.4,1.4,0.6l-0.1,0.2l-0.6-0.1c-0.1,0-0.1,0-0.2,0s-0.1,0.1-0.1,0.1c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.3-0.1,0.5
                 L36.2,99l2.6,1.2L40,99c0.2-0.2,0.3-0.3,0.4-0.4c0.1-0.1,0.2-0.2,0.2-0.2c0-0.1,0-0.1,0-0.2c0,0-0.1-0.1-0.1-0.1L40,97.7l0.1-0.2
                 c0.5,0.2,0.9,0.4,1.2,0.6c0.3,0.1,0.7,0.3,1.1,0.5l-0.1,0.2l-0.6-0.1c-0.2,0-0.3,0-0.4,0.1s-0.2,0.2-0.4,0.3l-5.7,5.3L34.7,104.1z
                  M38.3,100.5l-2.2-1l-0.3,3.4L38.3,100.5z"/>
               <path d="M24.7,95.3l0.2,0.1l-0.6,1.5c0.3,0.4,0.6,0.7,1,0.9c0.8,0.6,1.6,0.7,2.4,0.5s1.6-0.8,2.2-1.6c0.7-0.9,1-1.8,0.9-2.8
                 s-0.6-1.7-1.5-2.4c-0.5-0.4-1.1-0.7-1.8-0.9l0.1-0.2c0.9,0,1.8,0.3,2.6,0.9c1,0.7,1.6,1.7,1.8,2.7s-0.1,2.1-0.9,3.1
                 c-0.8,1.1-1.8,1.7-2.9,1.8s-2.3-0.2-3.4-1c-0.5-0.4-1-0.9-1.5-1.4l0-0.1L24.7,95.3z"/>
               <path d="M19.1,92.8l-1-1.1c-0.6-0.6-1.2-1.3-1.9-2l0-0.1l1.6-1l0.2,0.1l-0.8,1.2l1.8,2l2.4-2.2l-0.4-0.4c-0.3-0.3-0.6-0.6-0.9-1
                 c-0.1-0.1-0.2-0.1-0.2,0l-0.7,0.4L19,88.6c0.4-0.4,0.7-0.6,0.9-0.8c0.2-0.2,0.5-0.4,0.9-0.8l0.2,0.2l-0.5,0.7
                 c-0.1,0.1-0.1,0.2,0,0.2c0.3,0.4,0.6,0.7,0.9,1l0.4,0.4l1.6-1.4c0.3-0.3,0.6-0.6,0.9-0.9l-1.9-2.1l-1.6,0.5l-0.2-0.2l1.6-1.3l0.1,0
                 c0.7,0.8,1.3,1.5,1.9,2.1l0.9,1c0.3,0.3,0.6,0.7,1,1.1L26,88.6l-0.6-0.4c-0.1-0.1-0.2-0.1-0.2,0c-0.1,0.1-0.2,0.2-0.4,0.3
                 c-0.1,0.1-0.3,0.3-0.5,0.4l-3.5,3.2c-0.1,0.1-0.3,0.3-0.4,0.4s-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.2-0.1,0.2l0.3,0.7l-0.2,0.2
                 C19.8,93.5,19.4,93.2,19.1,92.8z"/>
               <path d="M13.2,85.6c-0.3-0.5-0.5-1-0.4-1.5c0.1-0.5,0.4-0.9,0.9-1.3c0.5-0.4,1.1-0.5,1.6-0.4c0.5,0.1,1,0.4,1.3,1
                 c0.3,0.5,0.5,1,0.4,1.6s-0.4,1-0.9,1.3c-0.5,0.3-1,0.4-1.6,0.3C14,86.4,13.6,86.1,13.2,85.6z M13.5,85.4c0.3,0.4,0.6,0.7,1,0.7
                 c0.4,0.1,0.9,0,1.3-0.3c0.5-0.3,0.7-0.7,0.8-1.1s0-0.9-0.3-1.3c-0.3-0.4-0.6-0.7-1.1-0.8c-0.4-0.1-0.9,0-1.3,0.4
                 c-0.4,0.3-0.7,0.7-0.8,1.1C13.1,84.6,13.2,85,13.5,85.4z M15.3,84.6c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1-0.1,0.2-0.1
                 c0,0,0.1-0.1,0.1-0.1L15.7,84l0.1-0.1c0.1,0.1,0.1,0.2,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.2
                 c0.1,0.1,0.1,0.2,0.2,0.2l-0.1,0.1l-0.2-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1L15,85.3
                 c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1l0.1,0.3L14.7,86c-0.1-0.1-0.1-0.2-0.2-0.3
                 c-0.1-0.1-0.1-0.2-0.2-0.2c0,0-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.2-0.2-0.2c-0.3-0.5-0.3-0.8,0-1c0.2-0.1,0.4-0.1,0.7,0.1
                 c0.1-0.2,0.2-0.3,0.2-0.5c0.1-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.1,0-0.2c0,0,0-0.1-0.1-0.2l0.1-0.1c0.1,0.1,0.1,0.2,0.2,0.2
                 c0.1,0.1,0.1,0.2,0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.1,0.3-0.2,0.4c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0.1,0,0.1
                 l0.1,0.1L15.3,84.6z M15,84.8c0,0,0-0.1-0.1-0.1c-0.2-0.3-0.4-0.3-0.6-0.2c-0.1,0.1-0.2,0.2-0.2,0.3s0,0.2,0.1,0.3
                 c0,0,0.1,0.1,0.1,0.1L15,84.8z"/>
             </g>
             <rect x="17.8" y="48.5" width="13.4" height="0.7"/>
             <rect x="18.1" y="65.5" width="13.1" height="0.7"/>
             <rect x="82.2" y="65.5" width="13.1" height="0.7"/>
             <rect x="82.2" y="48.5" width="13.4" height="0.7"/>
             </svg>`,
              },
            ],
          },
          {
            text: `${companyDisclaimer}`,
            alignment: 'right',
            style: 'disclaimer',
            width: '*',
          },
        ],
      },
      
      ...parameterValues
        .filter((item) => item.value)
        .map((item) => {
          return {
            columns: [
              {
                text: `${item.name}:`,
                style: "title",
                width: 150,
              },
              {
                text:
                  item.type === TEMPLATE_PARAM_DATE
                    ? renderDate(item.value)
                    : item.value,
                style: "value",
              },
            ],
          };
        })
    ],
   
    styles: {
      title: {
        color: "#222",
        fontSize: 10,
        margin: [0, 0, 0, 4],
      },
      value: {
        color: "#222",
        fontSize: 10,
        margin: [0, 0, 0, 4],
      },
      disclaimer: {
        color: "#222",
        position: 'absolute',
        textAlign: 'right',
        fontSize: 10,
        italics: true
      },
    },
  };
}

export function printLabel(qrCode: any, certificate: CertificateDto): void {
  const parameterValues = (certificate || {}).parameterValues || [];
  const { blockChainHashes } = certificate || {};
  const blockChainHash = (blockChainHashes || {}).certificateHash || "";

  loadImage("/ct_label_logo.png").then((logo) => {
    
    pdfMake
      .createPdf(
        getLabelDocDefinition(
          qrCode,
          certificate.id as string,
          blockChainHash,
          certificate.templateName,
          parameterValues,
          logo,
          certificate.companyDisclaimer,
        )
      )
      .open();
  });
}

export function saveLabel(qrCode: any, certificate: CertificateDto): void {
  const parameterValues = (certificate || {}).parameterValues || [];
  const { blockChainHashes } = certificate || {};
  const blockChainHash = (blockChainHashes || {}).certificateHash || "";

  loadImage("/ct_label_logo.png").then((logo) => {
    pdfMake
      .createPdf(
        getLabelDocDefinition(
          qrCode,
          certificate.id as string,
          blockChainHash,
          certificate.templateName,
          parameterValues,
          logo,
          certificate.companyDisclaimer,
        )
      )
      .download(certificate.id);
  });
}
